import React from 'react';
import IconLargeOrderWarning from './IconLargeOrderWarning';
import {LargeOrderBadgeWrap} from './styles';

const LargeOrderBadge = () => (
  <LargeOrderBadgeWrap>
    <IconLargeOrderWarning />
    Large order
  </LargeOrderBadgeWrap>
);

export default LargeOrderBadge;
